import {sizeOf} from 'ui/keyboard';

export function isEmpty(keyboard: KeyboardState): boolean {
  return sizeOf(keyboard) === 0;
}
